<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>Usuario</h1>
                <p>{{ user }}</p>
            </v-col>
        </v-row>
    </v-container>

</template>
<script>
export default { 
    name: "PerfilUsuario",
    data() { 
        return { 
            user: {}
        }
    },
    mounted() { 
        let idUsuario = this.$route.params.idUsuario
        window.console.log(idUsuario)
        if (idUsuario) this.getUsuario(idUsuario)
    },
    methods:{ 
        async getUsuario(id) { 
            const { data } = await this.$http('/users/'+id)
            window.console.log(data)
            this.user = data.data
        }
    }
}

</script>